import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import "./i18n-setup";
import { ModalsProvider } from "@dehub/theme";
import { Notifications } from "@dehub/theme";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { DehubThemeProvider } from "@dehub/theme";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { persistor, store } from "./store";
import "./styles/tokens.css";
import "./styles/base.css";

const themeOverride = {
  components: {
    Breadcrumbs: {
      styles: {
        breadcrumb: {
          color: "var(--mantine-color-gray-7)",
          fontSize: 14,
        },
      },
    },
  },
};

function Root() {
  return (
    <DehubThemeProvider themeOverride={themeOverride}>
      <ModalsProvider>
        <Notifications position="top-right" />
        <App />
      </ModalsProvider>
    </DehubThemeProvider>
  );
}

// A data router (not <BrowserRouter>) so useBlocker can guard unsaved work; App keeps its own <Routes>.
const router = createBrowserRouter([{ path: "*", element: <Root /> }], {
  basename: (window as any).__BASE_PATH__ || "",
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <RouterProvider router={router} />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();
